import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/routes';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { useLevelInfo } from '@/hooks/useGamification';
import { XpBar } from '@/components/gamification/XpBar';
import { NotificationsBell } from '@/components/notifications/NotificationsBell';
import { UserMenu } from './UserMenu';

export function TopBar() {
  const isDesktop = useIsDesktop();
  const level = useLevelInfo();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b border-parchment-border bg-parchment-light/95 px-4 backdrop-blur sm:px-6 lg:px-8">
      {!isDesktop && (
        <Link to={ROUTES.dashboard} className="inline-flex items-center gap-2 coarse:min-h-11">
          <span className="grid h-7 w-7 place-items-center rounded-md bg-accent text-parchment-light">
            <FlameIcon />
          </span>
          <span className="font-display text-lg text-parchment-ink">Ember</span>
        </Link>
      )}
      {level.data && (
        <div className="mx-auto hidden w-full max-w-sm sm:block">
          <XpBar level={level.data} />
        </div>
      )}
      <div className="flex items-center gap-1 sm:gap-2">
        <NotificationsBell />
        {/* The sidebar carries the user menu on desktop; on phones this is the
            only way to reach Settings, Communities, Challenges and Sign out. */}
        {!isDesktop && <UserMenu variant="compact" />}
      </div>
    </header>
  );
}

function FlameIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2c1.5 4 5 5.5 5 10a5 5 0 11-10 0c0-3 1.5-5 3-7 .8 1.5.5 3 2 5 0-3 0-5 0-8z" />
    </svg>
  );
}
